import React, { forwardRef } from 'react';
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  helperText,
  className = '',
  id,
  ...props
}, ref) => {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-358">
        {label && <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-359">
            {label}
          </label>}
        <input ref={ref} id={inputId} className={`
            w-full px-3 py-2 border rounded-lg text-gray-900
            placeholder:text-gray-400
            focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
            disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed
            ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300'}
            ${className}
          `} aria-invalid={error ? 'true' : 'false'} aria-describedby={error ? `${inputId}-error` : helperText ? `${inputId}-helper` : undefined} {...props} data-id="element-360" />
        {error && <p id={`${inputId}-error`} className="mt-1 text-sm text-red-600" data-id="element-361">
            {error}
          </p>}
        {helperText && !error && <p id={`${inputId}-helper`} className="mt-1 text-sm text-gray-500" data-id="element-362">
            {helperText}
          </p>}
      </div>;
});
Input.displayName = 'Input';